import { gettext } from '@eventbrite/i18n';
import classnames from 'classnames';
import React from 'react';
import { useGlobalNavContext } from '../../state';
import { getSigninOrSignupUrl, useGetSearchBarVariant } from '../../utils';
import {
    Logo,
    MobileDropdown,
    NavLink,
    ResultsPageSearchBar,
    SearchBar,
} from '../common';
import { NavItemType } from '../types';
import styles from './MobileNav.module.scss';

const MobileNav = () => {
    const { positionSticky, env, navigation } = useGlobalNavContext();
    const { mobile } = navigation ?? {};
    const dropdownItems = mobile as NavItemType[];
    const isSticky = positionSticky?.mobile ? 'mobileSticky' : '';
    const navClass = classnames(styles.nav, isSticky);

    //TODO: Search Page Hierarchy experiment cleanup EB-228109
    const isSearchBarExperiment = useGetSearchBarVariant();
    const isSearchPage: boolean =
        typeof window !== 'undefined' &&
        window.__SERVER_DATA__?.current_page === 'search';

    const shouldRenderResultsPageSearchBar =
        isSearchBarExperiment && isSearchPage;

    return (
        <nav
            aria-label={gettext('Main Mobile').toString()}
            data-testid="mobile-nav"
            className={navClass}
        >
            <ul className={styles.root}>
                <li className={styles.logo}>
                    <Logo />
                </li>
                <li className={styles.searchBar}>
                    {!shouldRenderResultsPageSearchBar && <SearchBar />}
                </li>

                <li className={styles.right}>
                    <ul className={styles.linkContainer}>
                        <li className={styles.listLink}>
                            <NavLink
                                heapIdentifier={'login'}
                                translatedText={gettext('Log In')}
                                path={getSigninOrSignupUrl(env?.signinUrl)}
                                className={styles.login}
                            />
                        </li>
                        <li className={styles.listLink}>
                            <NavLink
                                heapIdentifier={'signup'}
                                translatedText={gettext('Sign Up')}
                                path={getSigninOrSignupUrl(env?.signupUrl)}
                                className={styles.signup}
                            />
                        </li>
                        <MobileDropdown dropdownItems={dropdownItems} />
                    </ul>
                </li>
            </ul>
            <div className={styles.experimentSearchBar}>
                {shouldRenderResultsPageSearchBar && <ResultsPageSearchBar />}
            </div>
        </nav>
    );
};

export default MobileNav;
